import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  ExclamationCircleOutlined,
  CloseCircleOutlined,
  MinusCircleOutlined,
} from '@ant-design/icons';

export const useStatusRender = () => {
  return (status: string) => {
    switch (status) {
      case 'PENDING':
        return {
          icon: <ClockCircleOutlined />,
          text: 'Pending',
          color: '#faad14',
          bgColor: '#fff7e6',
          textColor: '#d48806',
          borderColor: '#ffd666',
        };
      case 'DONE':
        return {
          icon: <CheckCircleOutlined />,
          text: 'Done',
          color: '#52c41a',
          bgColor: '#f6ffed',
          textColor: '#389e0d',
          borderColor: '#b7eb8f',
        };
      case 'CANCELLED':
        return {
          icon: <CloseCircleOutlined />,
          text: 'Cancelled',
          color: '#ff4d4f',
          bgColor: '#fff2f0',
          textColor: '#cf1322',
          borderColor: '#ffb3b3',
        };
      case 'MISSED':
        return {
          icon: <MinusCircleOutlined />,
          text: 'Missed',
          color: '#8c8c8c',
          bgColor: '#f5f5f5',
          textColor: '#595959',
          borderColor: '#d9d9d9',
        };
      default:
        return {
          icon: <ExclamationCircleOutlined />,
          text: status || 'Unknown',
          color: '#d9d9d9',
          bgColor: '#fafafa',
          textColor: '#8c8c8c',
          borderColor: '#d9d9d9',
        };
    }
  };
};
